import { Building2 } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

export const companiesNavigation: NavItem[] = [
  {
    to: '/companies',
    labelKey: 'nav.companies',
    group: 'nav.groups.registry',
    icon: Building2,
    permission: 'companies.view',
  },
]
